export function getVersionParam () {
    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.get('version');
}

export function openUrlInNewTab (newUrl) {
    // Version is needed to ensure lookasides continue to work
    const version = getVersionParam();
    if (version) {
        newUrl += `?version=${version}`;
    }
    window.open(newUrl, '_blank');
}

export function eventIsOpeningANewTabOrWindow ($event) {
    return $event.metaKey || $event.ctrlKey || $event.shiftKey;
}
